( function ( $ ) {
	const $homeBanner_arrowDown = $(".content__header .arrow-down");

	$homeBanner_arrowDown.on("click", function(){
		$('html, body').animate({
			scrollTop: $('.content > .wrapper').offset().top
		}, 150);
	});

} )( jQuery );
